/**
 * Конвертер названий для лингвы
 * Название и префикс в CamelCase будут разделены знаком
 * Итоговая строка будет преобразована в UpperCase
 *
 * @param {string} name - название
 * @param {string} prefix - префикс
 * @param {string} separator - разделитель слов, по умолчанию '_'
 *
 * @example
 * // returns 'SCREEN_SEND_TICKET'
 * convertNameToLingvoStep('SendTicket', 'screen')
 *
 * @returns {string}
 */

export default (name = '', prefix = '', separator = '_') => {
  const regexp = /([a-z])([A-Z])/g;
  const subStr = `$1${separator}$2`;
  const upperCasePrefix = prefix.replace(regexp, subStr).toUpperCase();
  const upperCaseName = name.replace(regexp, subStr).toUpperCase();
  return prefix ? (upperCasePrefix + separator + upperCaseName) : upperCaseName;
};
